import type { PropsWithChildren } from 'react'

import css from './index.module.css'

import { Element } from '#/global/helper/Element'

export interface Props {
    itemsCount: number
    itemsPerPage: number
    page: number
    position?: 'bottom' | 'top'
    setPage: (page: number) => void
}

export const Pagination = ({ itemsCount, itemsPerPage, page, position, setPage }: Props) => {
    const pagesCount = Math.ceil(itemsCount / itemsPerPage)
    const previous = page - 1
    const next = page + 1
    const current = page

    const handlePageChange = (page: number) => {
        setPage(page)
        if (position === 'bottom') {
            const topPagination = document.querySelector('.r-pagination[data-target="top"]')
            if (topPagination) {
                window.scrollTo({ top: Element.getOffset(topPagination).top - 20, behavior: 'smooth' })
            }
        }
    }

    return (
        // generuje data-target="top" jenom když je position 'top'
        <div className={`r-pagination ${css.container}`} {...position === 'top' ? { 'data-target': 'top' } : {}}>
            <div className={css.pagination}>
                {current > 2 && <Button page={1} setPage={handlePageChange}>1</Button>}

                {/* separator */}
                {current > 3 && <div>...</div>}

                {/* prev page */}
                {previous > 0 && <Button page={previous} setPage={handlePageChange}>{previous}</Button>}

                {/* current page: inactive button */}
                <div className={`${css.item} ${css.active}`}>{current}</div>

                {/* next page */}
                {next <= pagesCount && <Button page={next} setPage={handlePageChange}>{next}</Button>}

                {/* separator */}
                {current <= pagesCount - 3 && <div>...</div>}

                {/* last page */}
                {current < pagesCount - 1 && <Button page={pagesCount} setPage={handlePageChange}>{pagesCount}</Button>}
            </div>
        </div>
    )
}

interface ButtonProps {
    page: number
    setPage: (page: number) => void
}

const Button = ({ children, page, setPage }: PropsWithChildren<ButtonProps>) => {
    return (
        <button className={css.item} onClick={() => setPage(page)} type="button">
            {children}
        </button>
    )
}
